import { 
    CREATE_WORKFLOW_REQUEST, 
    CREATE_WORKFLOW_SUCCESS, 
    CREATE_WORKFLOW_FAILURE, 
    FETCH_WORKFLOWS_REQUEST, 
    FETCH_WORKFLOWS_SUCCESS, 
    FETCH_WORKFLOWS_FAILURE, 
    UPDATE_WORKFLOW_REQUEST,
    UPDATE_WORKFLOW_SUCCESS,
    UPDATE_WORKFLOW_FAILURE,
    DELETE_WORKFLOW_REQUEST, 
    DELETE_WORKFLOW_SUCCESS, 
    DELETE_WORKFLOW_FAILURE 

} from "../actions/workflowActionTypes";




const initialState = {
    workflows: [], //Array to store the workflows fetched from the API
    isLoading: false, //Loading state for fetching workflows
    createWorkflowError: null, //Error state for creating a workflow
    fetchWorkflowsError: null, //Error state for fetching workflows
    updateWorkflowError: null, // Error state for updating a workflow
    configureWorkflowError: null, //Error state for configuring a workflow
    configureWorkflowPermissionsError: null, //Error state for configuring permissions for a workflow
    deleteWorkflowError: null, //Error state for deleting a workflow
};



const workflowReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_WORKFLOW_REQUEST:
            return {
                ...state,
                isLoading: true,
                addWorkflowError: null,
            };


        case CREATE_WORKFLOW_SUCCESS:
            return {
                ...state,
                workflows: [...state.workflows, action.payload],
                isLoading: false,
                createWorkflowError: null,
            };


        case CREATE_WORKFLOW_FAILURE:
            return {
                ...state,
                isLoading: false,
                createWorkflowError: action.payload,
            };


        case FETCH_WORKFLOWS_REQUEST:
            return {
                ...state,
                isLoading: true,
                fetchWorkflowsError: null, // Reset errors on request
            };


        case FETCH_WORKFLOWS_SUCCESS:
            return {
                ...state,
                workflows: action.payload,
                isLoading: false, // Stop loading
                fetchWorkflowsError: null, // Clear any previous fetch errors
            };


        case FETCH_WORKFLOWS_FAILURE:
            return {
                ...state,
                isLoading: false, //Stop loading
                fetchWorkflowsError: action.payload, // Store the error message
            };


        case UPDATE_WORKFLOW_REQUEST: 
            return {
                ...state,
                isLoading: true,
                updateWorkflowError: null
            };


        case UPDATE_WORKFLOW_SUCCESS: 
            return {
                ...state,
                workflows: state.workflows.map(workflow =>
                    workflow.id === action.payload.id ? action.payload : workflow
                ),
                isLoading: false,
                updateWorkflowError: null
            };


        case UPDATE_WORKFLOW_FAILURE: 
            return {
                ...state,
                isLoading: false,
                updateRoleError: action.payload
            };


        case DELETE_WORKFLOW_REQUEST:
            return {
                ...state,
                isLoading: true,
                deleteWorkflowError: null,
            };


        case DELETE_WORKFLOW_SUCCESS:
            return {
                ...state,
                workflows: state.workflows.filter((workflow) => workflow.id !== action.payload),
                isLoading: false,
                deleteWorkflowError: null,
            };


        case DELETE_WORKFLOW_FAILURE:
            return {
                ...state,
                isLoading: false,
                deleteWorkflowError: action.payload,
            };

            default:
                return state;
    }
};


export default workflowReducer